export const authScreens = {
  accesoDirecto: {
    loading: "Logowanie do konta…",
  },
  confirmar: {
    verifying: "Weryfikacja konta…",
    verifiedSuccess: "Konto zostało pomyślnie zweryfikowane",
    tokenInvalid: "Token nie istnieje albo już wygasł",
    backHome: "Powrót na stronę główną",
  },
  recovery: {
    title: "Zresetuj hasło",
    successTitle: "Gotowe!",
    successDesc:
      "Hasło zostało pomyślnie zmienione. Trwa przekierowanie na stronę startową…",
    infoTitle: "Utwórz nowe hasło",
    infoDesc:
      "Zmiana hasła wyloguje wszystkie aktywne sesje na innych urządzeniach.",
    newPasswordLabel: "Nowe hasło",
    newPasswordPlaceholder: "Wpisz nowe hasło",
    togglePasswordAria: "Pokaż/ukryj hasło",
    confirmPasswordLabel: "Powtórz hasło",
    confirmPasswordPlaceholder: "Powtórz nowe hasło",
    passwordsMismatch: "Hasła nie są takie same.",
    submit: "Zmień hasło",
    submitting: "Przetwarzanie…",
    backToStart: "Powrót na stronę startową",
    footerWeb: "Strona internetowa",
    toastInvalidLink: "Link do odzyskiwania hasła jest nieprawidłowy albo wygasł.",
    errorGeneric: "Nie udało się zmienić hasła.",
  },
};
